import { Button } from "@mantine/core";
import { useState } from "react";
import api from "../../../../../../api";
import { useToast } from "../../../../../../mantine/notifications/useToast";
import urls from "../../../../../../urls";
import type { TaskStatusResponse } from "../../../../../../utils/api-utils";
import { pollTaskStatus } from "../../../../../../utils/api-utils";
import type { Todo } from "../../../../../../utils/backend-types";

interface FormAdminButtonProps {
  todoId: number;
  onUpdateTodo: (todo: Todo) => void;
}

function FormAdminButton({ todoId, onUpdateTodo }: FormAdminButtonProps) {
  const { showToast, showErrorToast } = useToast();
  const [loading, setLoading] = useState(false);

  function handleDone() {
    api
      .get<Todo>(urls.api.todosDetail(todoId))
      .then((response) => {
        onUpdateTodo(response.data);
        showToast({
          type: "success",
          message:
            "Erstellung war erfolgreich. Neue Dokumente wurden an die Aufgabe angehängt."
        });
      })
      .catch((error) => {
        showErrorToast(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function handleError(error: unknown) {
    showErrorToast(error);
    setLoading(false);
  }

  function handleSubmit() {
    const url = urls.api.todoGenerateDocumentsAsFormAdmin(todoId);

    setLoading(true);

    api
      .post<TaskStatusResponse>(url, {})
      .then((response) => {
        const taskStatusUrl = response.data.taskStatusUrl;

        if (taskStatusUrl) {
          pollTaskStatus(taskStatusUrl, handleDone, handleError);
        } else {
          handleDone();
        }
      })
      .catch(handleError);
  }

  return (
    <Button color="warning" loading={loading} onClick={handleSubmit}>
      Form-Admin-Formulare erstellen
    </Button>
  );
}

export { FormAdminButton, FormAdminButtonProps };
